import React from "react";
import styled from "styled-components";

interface FilterIconProps {
  maxWidth?: number;
}

export default function FilterIcon({ maxWidth }: FilterIconProps) {
  return (
    <Icon className="material-icons-outlined" maxWidth={maxWidth}>
      filter_alt
    </Icon>
  );
}

const Icon = styled.span<FilterIconProps>`
  color: #aaafb9;
  width: 38px;
  height: 38px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: ${({ maxWidth }) => maxWidth ?? 1400}px) {
    display: none;
  }
`;
